import { render } from "./Home.vue?vue&type=template&id=7e007b0f"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=7e007b0f&lang=scss"

import exportComponent from "/var/www/patternmaking/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__